<template>
    <b-card>
        <b-row class="align-items-stretch">
            <b-col lg="6" class="mb-3">
                <b-card class="no-shadow h-100">
                    <div class="d-flex flex-column justify-content-center align-items-center">
                        <h4>{{ plan.product_name }}</h4>
                        <h5 class="text-dark">${{ amount }} / {{ plan.interval }}</h5>
                        <p>{{ price.name }}</p>
                        <p class="text-center">{{ plan.description }}</p>
                    </div>
                </b-card>
            </b-col>

            <b-col lg="6" class="mb-3">
                <b-card class="no-shadow h-100">
                    <PaymentMethodManager :payment-methods-url="paymentMethodsManagerData.paymentMethodsUrl"
                                          :max-payment-methods="paymentMethodsManagerData.maxPaymentMethods"
                                          :initial-payment-methods="paymentMethodsManagerData.paymentMethods"
                                          :selectable="true"
                                          :removable="false"
                                          :organization="paymentMethodsManagerData.organization"
                                          @onSelect="handlePaymentMethodSelected"
                                          @onRemove="selectedPaymentMethod = null"/>
                </b-card>
            </b-col>
        </b-row>

        <b-row class="justify-content-end">
            <b-col cols="auto">
                <b-form method="post" action="/customers/subscriptions" ref="createSubscriptionForm">
                    <input type="hidden" :value="csrfToken" name="authenticity_token"/>
                    <input type="hidden" :value="paymentMethodStripeId" name="payment_method_id"/>
                    <input type="hidden" :value="price.id" name="price_id"/>
                    <b-button variant="primary"
                              @click="agreementModal = true"
                              class="btn-rounded px-2 py-1"
                              :disabled="!selectedPaymentMethod || loading">
                        Create Subscription
                    </b-button>
                </b-form>


            </b-col>
        </b-row>

        <b-modal v-model="agreementModal" ok-title="Continue" :ok-disabled="!acceptedTerms" title="Terms and Conditions" @ok="handleSubmit">
            <div v-html="agreement" class="pb-3"></div>
            <b-form-checkbox v-model="acceptedTerms">
                I accept the Subscription Terms
            </b-form-checkbox>
        </b-modal>

    </b-card>
</template>

<script>
import PaymentMethodManager from "../PaymentMethods/PaymentMethodManager";
import GeneralMixins from "../../../mixins/GeneralMixins";

export default {

  props: ['plan', 'priceId', 'paymentMethodsManagerData', 'agreement'],
  mixins: [GeneralMixins],

  data() {
    return {
      selectedPaymentMethod: null,
      agreementModal: false,
      acceptedTerms: false,
      loading: false
    }
  },

  computed: {

    price() {
      return this.plan.prices.find(p => p.id === this.priceId)
    },

    amount() {
      return this.formatPrice(this.price.amount / 100)
    },

    paymentMethodStripeId() {
      if (!this.selectedPaymentMethod) { return null }
      return this.selectedPaymentMethod.stripe_id
    }

  },

  methods: {
    handlePaymentMethodSelected(method) {
      this.selectedPaymentMethod = method
    },

    handleSubmit() {
      this.loading = true
      this.$refs.createSubscriptionForm.submit()
    }
  },

  components: {PaymentMethodManager}
}
</script>